import { isValidElement, ReactNode } from "react";
import { Link } from "../../../i18n/components";

const renderExternalLink = (uri: string, children: ReactNode) => (
  <a href={uri} target="blank" title={getStringFromObject(children)}>
    {children}
  </a>
);

const renderInternalLink = (uri: string, children: ReactNode) => {
  return (
    <Link href={uri} passHref title={getStringFromObject(children)}>
      {children}
    </Link>
  );
};

const getStringFromObject = (children: ReactNode): string => {
  if (Array.isArray(children)) {
    const [firstChild] = children;
    if (isValidElement<{ children?: ReactNode }>(firstChild) && typeof firstChild.props.children === "string") {
      return firstChild.props.children;
    }
  }
  return "";
};

export const linkRenderer = {
  renderExternalLink,
  renderInternalLink,
};
